module.exports = __webpack_public_path__ + "img/GPB.65f2888e.png";